import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import moment from "moment";
import { VaporDatePicker } from "../../../../vapor";
import { Select } from "antd";

import NumberFormat from "react-number-format";
import numeral from "numeral";

/**
 * Sub section where use can add a revaluation
 * @returns 
 */
const RevaluationSubSectionStep1 = ({ fields, setFields, minDatePicker }) => {  
  const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY", "DDMMYYYY", "DDMMYY"];
  const [currentAssetValue, setCurrentAssetValue] = useState(null);

  useEffect(() => {
    
    setCurrentAssetValue(fields?.currentValue);
  }, [JSON.stringify(fields?.currentValue)]);
    
  return (
    <div className='pre-cog-assets-drawer-revaluation'>

      <div className='pre-cog-assets-drawer-revaluation-row'>
        <div className='pre-cog-assets-drawer-revaluation-col'>
          <div className='pre-cog-assets-drawer-revaluation-label'>
            <FormattedMessage id="preCog.assetsTab.drawer.movements.currentAssetValue" />            
          </div>
          <NumberFormat
            allowEmptyFormatting={false}
            allowLeadingZeros={true}
            displayType={"input"}            
            decimalScale={2}
            thousandSeparator={"."}
            decimalSeparator={","}              
            className="inputCustom drawer-inputCustom pre-cog-assets-drawer-revaluation-field"
            placeholder="-"
            suffix={"€"}           
            value={currentAssetValue !== 0 ? numeral(currentAssetValue).format("0,0.00") : null}
            onValueChange={(el) => {   
              setCurrentAssetValue( (el.floatValue === undefined ? 0 : el.floatValue || null) );                                                                                            
            }}       
            onBlur={() => {
              setFields(prev => ({ ...prev, currentValue: (currentAssetValue === undefined ? 0 : currentAssetValue || null) }));                                                            
            }}       
            
          />       
        </div>
        <div className='pre-cog-assets-drawer-revaluation-col'>
          <div className='pre-cog-assets-drawer-revaluation-label'>
            <FormattedMessage id="preCog.assetsTab.drawer.movements.effectiveDate" />   
            *</div>
          <VaporDatePicker
            disabledDate={(current) => {    
              return current && (current < moment(minDatePicker, "YYYY-MM-DD"));
            }} 
            getPopupContainer={(trigger) => trigger.parentNode}
            className='pre-cog-assets-drawer-revaluation-field'
            value={fields.revaluationDate}
            format={dateFormatList}
            allowClear={true}
            onChange={(e) => setFields(prev => ({ ...prev, revaluationDate: e }))}
          />
        </div>
      </div>
      <div className='pre-cog-assets-drawer-revaluation-row'>
        <div className='pre-cog-assets-drawer-revaluation-col'>
          <div className='pre-cog-assets-drawer-revaluation-label'>
            <FormattedMessage id="preCog.assetsTab.drawer.movements.movementType" />  
            *</div>
          <Select
            className='pre-cog-assets-drawer-revaluation-field'
            value={fields.revaluationType}
            onChange={value => {
              setFields(prev => ({ ...prev, revaluationType: value }));
            }}
            placeholder={<FormattedMessage id="preCog.assetsTab.drawer.existingAssetValue" />}
            getPopupContainer={(trigger) => trigger.parentNode}
          >
            <Select.Option value="REV_COST"><FormattedMessage id="preCog.assetsTab.drawer.movements.REV_COST" /></Select.Option>
            <Select.Option value="REV_COST_AND_FUND"><FormattedMessage id="preCog.assetsTab.drawer.movements.REV_COST_AND_FUND" /></Select.Option>
            <Select.Option value="DECR_FUND"><FormattedMessage id="preCog.assetsTab.drawer.movements.DECR_FUND" /></Select.Option>
          </Select>
        </div>
        <div className='pre-cog-assets-drawer-revaluation-col'>
          <div className='pre-cog-assets-drawer-revaluation-label'>
            <FormattedMessage id="preCog.assetsTab.drawer.movements.applicationType" />  
          *</div>
          <Select
            className='pre-cog-assets-drawer-revaluation-field'
            value={fields.applicationField}
            onChange={value => {
              setFields(prev => ({ ...prev, applicationField: value }));
            }}
            placeholder={<FormattedMessage id="preCog.assetsTab.drawer.existingAssetValue" />}
            getPopupContainer={(trigger) => trigger.parentNode}
          >
            {/* Commentato su ordine di Elda
            <Select.Option value="TAX">
              <FormattedMessage id="preCog.assetsTab.drawer.movements.TAX" />  
            </Select.Option>
            */}
            <Select.Option value="STATUTORY">
              <FormattedMessage id="preCog.assetsTab.drawer.movements.STATUTORY" /> 
            </Select.Option>
            <Select.Option value="STATUTORY_AND_TAX">
              <FormattedMessage id="preCog.assetsTab.drawer.movements.STATUTORY_AND_TAX" /> 
            </Select.Option>
          </Select>
        </div>
      </div>
    </div>
  );
};

export default RevaluationSubSectionStep1;
